export var ChangeEntityTypeEnum;
(function (ChangeEntityTypeEnum) {
    ChangeEntityTypeEnum["FEED"] = "Feed";
    ChangeEntityTypeEnum["MESSAGE_TEMPLATE"] = "MessageTemplate";
    ChangeEntityTypeEnum["LAYOUT"] = "Layout";
    ChangeEntityTypeEnum["NOTIFICATION_TEMPLATE"] = "NotificationTemplate";
    ChangeEntityTypeEnum["NOTIFICATION_GROUP"] = "NotificationGroup";
})(ChangeEntityTypeEnum || (ChangeEntityTypeEnum = {}));
